// Page interface + hash router. Each page owns its DOM lifecycle.

export interface Page {
  mount(container: HTMLElement): void;
  unmount?(): void;
  onShow?(): void;
}

export type PageFactory = () => Page;

export class Router {
  private routes = new Map<string, PageFactory>();
  private container: HTMLElement;
  private current: Page | null = null;

  constructor(container: HTMLElement) {
    this.container = container;
    window.addEventListener('hashchange', () => this.render());
  }

  add(path: string, factory: PageFactory): void {
    this.routes.set(path, factory);
  }

  start(): void {
    // 直接渲染一次;用 replaceState 而不是 location.hash=,避免触发 hashchange
    // 造成 mount() 还没 append DOM 时第二次 render 已经 innerHTML='' 清空。
    if (!location.hash) {
      this.render();
      history.replaceState(null, '', '#/tuning');
    } else {
      this.render();
    }
  }

  private render(): void {
    const path = location.hash.slice(1) || '/tuning';
    const factory = this.routes.get(path) ?? this.routes.get('/tuning');
    if (!factory) return;
    this.current?.unmount?.();
    this.container.innerHTML = '';
    const page = factory();
    this.current = page;
    page.mount(this.container);
    page.onShow?.();
    // Update nav active states.
    document.querySelectorAll('.nav button').forEach((b) => {
      b.classList.toggle('active', b.getAttribute('data-route') === path);
    });
  }
}
